/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Tab_Storybank_DescInputs */

const en_landing_tab_storybank_desc = /** @type {(inputs: Landing_Tab_Storybank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store your career achievements in STAR format. AI pulls the right stories for each application — no more rewriting from scratch.`)
};

const de_landing_tab_storybank_desc = /** @type {(inputs: Landing_Tab_Storybank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichere deine Karriere-Erfolge im STAR-Format. KI wählt die richtigen Geschichten für jede Bewerbung — nie wieder von Null anfangen.`)
};

const fr_landing_tab_storybank_desc = /** @type {(inputs: Landing_Tab_Storybank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store your career achievements in STAR format. AI pulls the right stories for each application — no more rewriting from scratch.`)
};

const es_landing_tab_storybank_desc = /** @type {(inputs: Landing_Tab_Storybank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store your career achievements in STAR format. AI pulls the right stories for each application — no more rewriting from scratch.`)
};

const it_landing_tab_storybank_desc = /** @type {(inputs: Landing_Tab_Storybank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store your career achievements in STAR format. AI pulls the right stories for each application — no more rewriting from scratch.`)
};

const nl_landing_tab_storybank_desc = /** @type {(inputs: Landing_Tab_Storybank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store your career achievements in STAR format. AI pulls the right stories for each application — no more rewriting from scratch.`)
};

const pl_landing_tab_storybank_desc = /** @type {(inputs: Landing_Tab_Storybank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store your career achievements in STAR format. AI pulls the right stories for each application — no more rewriting from scratch.`)
};

const fi_landing_tab_storybank_desc = /** @type {(inputs: Landing_Tab_Storybank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store your career achievements in STAR format. AI pulls the right stories for each application — no more rewriting from scratch.`)
};

const da_landing_tab_storybank_desc = /** @type {(inputs: Landing_Tab_Storybank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store your career achievements in STAR format. AI pulls the right stories for each application — no more rewriting from scratch.`)
};

const sv_landing_tab_storybank_desc = /** @type {(inputs: Landing_Tab_Storybank_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store your career achievements in STAR format. AI pulls the right stories for each application — no more rewriting from scratch.`)
};

/**
* | output |
* | --- |
* | "Store your career achievements in STAR format. AI pulls the right stories for each application — no more rewriting from scratch." |
*
* @param {Landing_Tab_Storybank_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_tab_storybank_desc = /** @type {((inputs?: Landing_Tab_Storybank_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Tab_Storybank_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_tab_storybank_desc(inputs)
	if (locale === "fr") return fr_landing_tab_storybank_desc(inputs)
	if (locale === "es") return es_landing_tab_storybank_desc(inputs)
	if (locale === "it") return it_landing_tab_storybank_desc(inputs)
	if (locale === "nl") return nl_landing_tab_storybank_desc(inputs)
	if (locale === "pl") return pl_landing_tab_storybank_desc(inputs)
	if (locale === "fi") return fi_landing_tab_storybank_desc(inputs)
	if (locale === "da") return da_landing_tab_storybank_desc(inputs)
	if (locale === "sv") return sv_landing_tab_storybank_desc(inputs)
	return en_landing_tab_storybank_desc(inputs)
});